import Script from "next/script";
import { ClarityScript } from "src/analytics/scripts/clarity-script";
import { getGlobals } from "src/constants/globals";
import { getRuntimeConfig } from "src/utils/runtime-config";

export const ThirdPartyScripts = () => {
    const { dynatraceRumEnabled: isRumEnabled, dynatraceRumTagUrl } = getRuntimeConfig();
    const { isEnabled: isClarityEnabled, projectId: clarityProjectId } = getGlobals()?.clarity ?? {};

    return (
        <>
            {isClarityEnabled && clarityProjectId ? <ClarityScript clarityProjectId={clarityProjectId} /> : null}
            {isRumEnabled && dynatraceRumTagUrl ? (
                <Script src={dynatraceRumTagUrl.toLowerCase()} strategy="beforeInteractive" crossOrigin="anonymous" />
            ) : null}
        </>
    );
};
